import { LayoutDesktop } from '@/components/LayoutPC/LayoutDesktop'
import './DQuiz.scss'
import { QuestionModel } from '@/models/typing'
import produce from 'immer';
import { useRecoilCallback, useRecoilState } from 'recoil';
import { quizState, submitAmswerState } from '@/models/quizState';
import { QuizAnswerComponent, countdownState } from '../Mobile/MQuiz';
import { formatTime } from '@/utils/util';
import { useEffect } from 'react';
import { QuizAlert, QuizAlertTypes, alertLoadingState } from '@/components/Alert';
import { ImageViewer, Toast } from 'antd-mobile';
import { useLocation, useNavigate } from 'react-router-dom';
import { Tracking } from '@/utils/tracking';
import BlankPage from '@/components/Error/blank';
import moment from 'moment';
import { paperState } from '../Mobile/MPaper';
import { CError } from '@/utils/server';

type QuizQuestionComponentProps = {
    index: number,
    question: QuestionModel,
    children?: React.ReactNode,
    allowClick?: boolean
}



export const DQuizQuestionComponent = ({ index, question, children, allowClick }: QuizQuestionComponentProps) => {

    const [quiz, setQuiz] = useRecoilState(quizState)

    return (
        <div className="desktop-question-item">
            <p className="desktop-question-item-title">{`${index + 1}. ${question.title}`}</p>
            {
                question.img.length > 0 && <img
                    className="desktop-question-item-img pointer"
                    src={question.img}
                    onClick={(event) => {
                        event.stopPropagation()
                        setQuiz(produce(quiz, (draftState) => {
                            draftState.image = question.img
                            draftState.visible = true
                        }))
                    }}
                    alt='colg'
                />
            }
            {
                question.answer_list.map((item, index) => (
                    <QuizAnswerComponent key={index} question={question} item={item} index={index} allowClick={allowClick ?? true} />
                ))
            }
            {
                children && children
            }
            <div className='divider'></div>
        </div>
    )
}


export const DesktopQuiz = () => {

    const navigate = useNavigate()

    const [quiz, setQuiz] = useRecoilState(quizState)

    const location = useLocation()

    const [paper, setPaper] = useRecoilState(paperState)

    const [countdown, setCountdown] = useRecoilState(countdownState)

    const [alertLoading, setAlertLoading] = useRecoilState(alertLoadingState)

    const submitAnswers = useRecoilCallback(({ snapshot }) => async () => {
        try {
            setAlertLoading(true)
            const result = await snapshot.getPromise(submitAmswerState)
            setAlertLoading(false)
            setPaper(result)
            navigate('/paper', { replace: true })
            setQuiz(produce(quiz, (draftState) => {
                draftState.alertType = QuizAlertTypes.TIMEOUT
                draftState.alert = true
            }));
        } catch (error) {
            setAlertLoading(false)
            const err = error as CError
            if(err.code === 756004){
                navigate('/', { replace: true })
            }
            Toast.show({ content: err.message })
        }
    }, [alertLoading, paper])



    useEffect(() => {
        window.scrollTo(0, 0)
    }, [location]);


    useEffect(() => {
        if (quiz.questionnaire && quiz.questionnaire.answer_time > 0) {
            let animationFrameId: number;
            let startTime: number;

            const currentTime = moment();
            const targetDate = currentTime.add(quiz.questionnaire.answer_time, 'seconds'); 
            const startTimer = (timestamp: number) => {
                if (!startTime) {
                    startTime = timestamp;
                }

                const now = moment();
                const diff = targetDate.diff(now);
                if (diff <= 0) {
                    cancelAnimationFrame(animationFrameId);
                    submitAnswers();
                } else {
                    const seconds = Math.floor(diff / 1000);
                    console.log(seconds);
                    
                    setCountdown(seconds);
                    animationFrameId = requestAnimationFrame(startTimer);
                }
            };

            animationFrameId = requestAnimationFrame(startTimer);

            return () => {
                cancelAnimationFrame(animationFrameId);
            };
        }

    }, [setCountdown]);


    if (quiz.questionList.length === 0) {
        return <BlankPage />
    }

    return (
        <LayoutDesktop guideOnClick={()=>{
            setQuiz(produce(quiz, (draftState) => {
                draftState.alertType = QuizAlertTypes.GUIDE
                draftState.alert = true
            }));
        }} honorsOnClick={ ()=> {
            setQuiz(produce(quiz, (draftState) => {
                draftState.alertType = QuizAlertTypes.HONORS
                draftState.alert = true
            }));
        }}>
            <div className='desktop-quiz-content'>
                <div className='desktop-quiz-top'>
                    <p className='desktop-quiz-top-title'>{quiz.questionnaire?.title ?? ''}</p>
                    {
                        (quiz.questionnaire && quiz.questionnaire.answer_time > 0) && <div className="desktop-quiz-top-countdown">
                            <div className="desktop-quiz-top-countdown-clock"></div>
                            <p className="desktop-quiz-top-countdown-timeline">{formatTime(countdown)}</p>
                        </div>
                    }
                </div>
                {
                    quiz.questionList.map((item, index) => (
                        <DQuizQuestionComponent key={index} question={item} index={index} />
                    ))
                }
            </div>
            <div className='desktop-quiz-control'>
                <div className='desktop-quiz-control-left pointer' onClick={() => {
                    setQuiz(produce(quiz, (draftState) => {
                        draftState.alertType = QuizAlertTypes.REMIND
                        draftState.alert = true
                    }));
                }}></div>
                <div className='desktop-quiz-control-right pointer' onClick={() => {
                    Tracking.UP('click_all_answer_QuestionBank_submit', '', { 'title': quiz.questionnaire?.title ?? '' })
                    setQuiz(produce(quiz, (draftState) => {
                        draftState.alertType = QuizAlertTypes.PAPER
                        draftState.alert = true
                    }));
                }}></div>
            </div>
            <ImageViewer
                image={quiz.image}
                visible={quiz.visible}
                onClose={() => {
                    setQuiz(produce(quiz, (draftState) => {
                        draftState.image = ''
                        draftState.visible = false
                    }))
                }}
            />
            {quiz.alert && <QuizAlert />}
        </LayoutDesktop>
    )

}


